<div class="p-2">
  <!-- Title -->
  <div class="row">
    <div class="col-12 h5 text-muted p-0">Coupon Report</div>
  </div>

  <div class="row bg-light p-2">
    <div class="col-12">

      <!-- Filters -->
      <div class="row bg-white pt-2 pb-2">
        <div class="col-12">
          <app-page-filters page="coupon-report" [showManufacturer]="false" [showCouponSource]="false" [showCalendar]="false" (filterChange)="onPageFilterChange($event)"></app-page-filters>
        </div>
      </div>

      <!-- Report -->
      <div class="row bg-white mt-2 pt-2 pb-2">
        <div class="col-12">

          <!-- Pagination -->
          <div class="row pagination-row mt-0 m-1">
            <div class="col-1">
              <select class="form-select form-select-sm mt-1" [(ngModel)]="couponsPageSize" (change)="onPageSizeChange($event)" [disabled]="couponsLoading">
                <option *ngFor="let item of pageSize" [value]="item.value">{{ item.value }}</option>
              </select>
            </div>
            <div class="col-2 label text-muted">
              <div class="mt-2">records per page</div>
            </div>
            <div class="col-9">
              <pagination-controls class="label float-end mt-1" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCouponsPageChange($event)" *ngIf="couponsCount > 0"></pagination-controls>
            </div>
          </div>

          <!-- Header -->
          <div class="row coupons-header-row border-bottom m-1">
            <div class="col-1 title text-muted cursor-pointer" (click)="changeSorting('coupon_image')">
              Image
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'coupon_image'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'coupon_image'"></i-bs>
            </div>
            <div class="col-4 title text-muted cursor-pointer" (click)="changeSorting('coupon_title')">
              Title
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'coupon_title'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'coupon_title'"></i-bs>
            </div>
            <div class="col-3 title text-muted">
              Products
            </div>
            <div class="col-1 title text-muted cursor-pointer" (click)="changeSorting('clips_count')">
              Clips
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'clips_count'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'clips_count'"></i-bs>
            </div>
            <div class="col-1 title text-muted cursor-pointer" (click)="changeSorting('redeems_count')">
              Redemptions
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'redeems_count'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'redeems_count'"></i-bs>
            </div>
            <!--<div class="col-1 title text-muted">
              Sales Amount
            </div>
            <div class="col-1 title text-muted">
              Units Sold
            </div>-->
            <div class="col-1 title text-muted cursor-pointer" (click)="changeSorting('start_date')">
              Start Date
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'start_date'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'start_date'"></i-bs>
            </div>
            <div class="col-1 title text-muted cursor-pointer" (click)="changeSorting('date')">
              End Date
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'date'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'date'"></i-bs>
            </div>
          </div>

          <!-- Loader & Empty message -->
          <div class="row mt-4 mb-4">
            <div class="col-12 text-center">
              <div class="spinner-border text-info mt-4 mb-4" role="status" *ngIf="couponsLoading === true"></div>

              <div class="mt-4 pt-4" *ngIf="couponsLoading === false && coupons.length == 0">
                <i-bs class="text-black-50 mt-4 pt-4" name="barChart" width="30" height="30"></i-bs>
                <div class="col-12 text-center text-black-50 mb-4 pb-4">Data not found</div>
              </div>
            </div>
          </div>

          <!-- Coupons -->
          <div class="row coupons-row border-bottom border-light m-1" *ngFor="let coupon of coupons | paginate: { itemsPerPage: couponsPageSize, currentPage: couponsPage, totalItems: couponsCount }; let i = index;">
            <div class="col-1">
              <img class="img" [src]="coupon.coupon_image" alt="...">
            </div>
            <div class="col-4 value text-muted">
              {{ coupon.coupon_title }}
            </div>
            <div class="col-3 value text-muted" *ngIf="coupon.products.length == 0">
              N/A
            </div>
            <div class="col-3 value text-muted" *ngIf="coupon.products.length > 0">
              {{ coupon.products[0].item_name }} ({{ coupon.products[0].upc }}) <span *ngIf="coupon.products.length > 1"> and {{ coupon.products.length - 1 }} more</span>
            </div>
            <div class="col-1 value text-muted" >
              {{ coupon.clips_count | number }}
            </div>
            <div class="col-1 value text-muted">
              {{ coupon.redeems_count | number }}
            </div>
            <!--<div class="col-1 value text-muted">
              <div class="spinner-grow spinner-grow-sm" role="status" *ngIf="coupon.item_amount == null"></div>
              <span *ngIf="coupon.item_amount != null">{{ coupon.item_amount | currency  }}</span>
            </div>
            <div class="col-1 value text-muted">
              <div class="spinner-grow spinner-grow-sm" role="status" *ngIf="coupon.units_sold == null"></div>
              <span *ngIf="coupon.units_sold != null">{{ coupon.units_sold | number  }}</span>
            </div>-->
            <div class="col-1 value text-muted">
              {{ coupon.start_date | date : 'MMM d, y' : 'UTC' }}
            </div>
            <div class="col-1 value text-muted">
              {{ coupon.coupon_expiration.date | date : 'MMM d, y' : 'UTC' }}
            </div>
          </div>

          <!-- Pagination -->
          <div class="row pagination-row mt-0 m-1">
            <div class="col-12">
              <pagination-controls class="label float-end mt-1" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCouponsPageChange($event)" *ngIf="couponsCount > 0"></pagination-controls>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>
